import React from "react";

import InternalSelectors from "./InternalSelectors";

const CompetenciesFields = ({
  competenceCount,
  competencesStore,
  grade,
  subject,
  data,
}) => {
  const amountOfFieldsToDisplay = Array.from(
    { length: competenceCount },
    (x, i) => i
  );

  return (
    <>
      {amountOfFieldsToDisplay.map((element) => {
        return (
          <React.Fragment key={`competence-${element}`}>
            <InternalSelectors
              grade={grade}
              subject={subject}
              competencesStore={competencesStore}
              data={data}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CompetenciesFields;
